import React from 'react'
import { DropdownButton, Dropdown } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCross } from '@fortawesome/free-solid-svg-icons'

const AdminBoxTop = () => {
  return (
    <DropdownButton className='text-end' variant='outline-dark m-2 text-align-end' id="dropdown-basic-button" title="Ilker Akbiyik">
      <p className='px-3 fs-5'>Super Admin</p>
      <Dropdown.Divider></Dropdown.Divider>
      <p className='px-3 d-flex justify-content-between'>
        Item 
        <FontAwesomeIcon className='text-info fs-4' icon={faCheck} /> 
      </p>
      <p className='px-3 d-flex justify-content-between'>
        Discount
        <FontAwesomeIcon className='text-info fs-4' icon={faCheck} /> 
      </p>
      <p className='px-3 d-flex justify-content-between'>
        Goal
        <FontAwesomeIcon className='text-info fs-4' icon={faCheck} /> 
      </p>
      <p className='px-3 d-flex justify-content-between'>
        Users
        <FontAwesomeIcon className='text-info fs-4' icon={faCheck} /> 
      </p>
    </DropdownButton>
  )
}

export default AdminBoxTop